import { Component, inject, input, OnInit, signal } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { NavController, ActionSheetController } from '@ionic/angular/standalone';
import { User } from '@chemist2u/types-client/C2U/ParseObjects';
import { ProfileHeaderComponent } from '../../elements/profile-header/profile-header.component';
import { RowComponent } from '../../elements/row/row.component';
import { AuthService } from '../../../services/auth.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

@Component({
    selector: 'app-profile-auth',
    templateUrl: './profile-auth.component.html',
    styleUrls: ['./profile-auth.component.scss'],
    imports: [ProfileHeaderComponent, RowComponent]
})
export class ProfileAuthComponent implements OnInit {
  private actionSheetController = inject(ActionSheetController);
  private navCtrl = inject(NavController);
  private $auth = inject(AuthService);
  private $amplitude = inject(AmplitudeService);
  public user = input.required<User>();

  onMobile = signal<boolean>(false);

  ngOnInit() {
    this.onMobile.set(Capacitor.isNativePlatform());
  }

  navigate(location: string) {
    this.navCtrl.navigateForward(location);
  }

  async logout() {
    const actionSheet = await this.actionSheetController.create({
      buttons: [{
        text: 'Log out',
        role: 'destructive',
      }, {
        text: 'Cancel',
        role: 'cancel',
      }]
    });

    await actionSheet.present();
    const { role } = await actionSheet.onDidDismiss();
    
    if (role == 'destructive') {
      this.$auth.logOut();
    }
  }

  async getHelp() {
    await Browser.open({ url: 'https://www.chemist2u.com.au/app-help', presentationStyle: "popover" });
    this.$amplitude.track('OPEN_EXTERNAL_HELP');
  }

}